import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export default function insertInArray(array, key, item) {
  var position = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'before';
  var find = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (key) {
    return function (item) {
      return item === key;
    };
  };
  var index = array.findIndex(find(key));
  var before = position === 'before';
  var fistPart = array.slice(0, index + (before ? 0 : 1));
  var lastPart = array.slice(index + (before ? 0 : 1), array.length - 1);
  return [].concat(_toConsumableArray(fistPart), [item], _toConsumableArray(lastPart));
}